<template>
  <div class="order-panel"
       v-if="showOrder">
    <div class="state "></div>
    <div class="panel-body">
      <div class="title clearfix type-hebing">
        <label style="font-weight:400;">
          <i class="fa fa-tuan tb"
             v-if="isGroup"></i>
          <span v-if="item.various[0].orderText"
                :class="'hidden-xs order-type ' + item.various[0].orderType">{{item.various[0].orderText}}</span>
          <span class="detail hidden-xs">下单时间:{{item.order_at|formatYMDHMS}}</span>
          <span class="detail order-no">订单号:{{item.order_no}}</span>
        </label>
        <template v-if="item.product_type!==15">

        <span v-if="Number(item.state) !== Number(stateMap.NOT_PAY)"
              :class="'pull-right ' + (Number(item.state) === Number(stateMap.HAS_PAYED) ? 'success':'default')">
          <i class="hidden-xs status-divider-v"></i>
          <!-- 订单倒计时 -->
          <span>{{orderStatus[item.state]}}</span>
        </span>
        <span v-else
              class="pull-right warning">
          <i class="hidden-xs status-divider-v"></i>
          <!-- 订单倒计时 -->
          <span>{{orderStatus[item.state]}}</span>
          <span class="time-wrap">剩余&nbsp;&nbsp;<span class="time">{{timestamp|payCountDown}}</span></span>
        </span>
        </template>
      </div>
      <div class="order-content clearfix"
           :class="{ more_data: item.various.length > 1 }">
        <!-- phone中的未支付的 -->
        <p v-if="Number(item.state) !== Number(stateMap.NOT_PAY)"
           :class="'state ' + (Number(item.state) === Number(stateMap.HAS_PAYED) ? 'success':'default')">
          <i class="status-divider-v"></i>
          <!-- 订单倒计时 -->
          <span>{{orderStatus[item.state]}}</span>
        </p>
        <!-- phone -->
        <p v-else
           class="state warning">
          <i class="status-divider-v"></i>
          <!-- 正常订单倒计时 -->
          <span>{{orderStatus[item.state]}}</span>
          <!-- 团购订单倒计时 -->
          <span class="time-wrap">剩余&nbsp;&nbsp;<span class="time">{{timestamp|payCountDown}}</span></span>
        </p>
        <slot v-for="(order, index) in item.various">
          <slot v-if="index < 3">
            <div class="item-class"
                 :class="{noneMar: (item.various.length-1) === index}"
                 :key="order.order_no">
              <!-- pc端 -->
              <div class="order-name neworder-name">
                <span v-if="item.various[0].orderText"
                      :class="'visible-xs order-type ' + item.various[0].orderType">{{item.various[0].orderText}}</span>
                {{order.subject}}
                <div class="order_time" v-show="order.begin_at">
                  <i class="fa fa-calendar"></i>
                  {{order.begin_at|formatDate}}-{{order.end_at|formatDate}}
                </div>
              </div>
              <hr>
            </div>
          </slot>
        </slot>
        <div class="surplus noneMar"
             v-if="item.various.length > 3">
          ...余{{item.various.length-3}}项
        </div>
        <div class="newbtn">
          <span>
            <el-button v-if="isNotPay"
                       class="go-pay"
                       @click="goPay(item.order_no)"
                       type="primary">去支付</el-button>
            <div class="btn-cancel"
                 v-if="isNotPay"
                 @click="cancelPay(item.order_no)">取消订单</div>
            <el-button v-if="showShareBtn"
                       class="phone-gopay"
                       @click="showGroup"
                       type="danger">分享完成拼团</el-button>
            <el-button :disabled="item.addCarDisabled"
                       type="primary"
                       style="width: auto"
                       plain
                       v-if="showAddCard&&item.various[0].activity_type!==2"
                       @click="addCart($event, item)">重新加入购课单</el-button>
            <el-button class="class-detail"
                       @click="findOrder">订单详情</el-button>
          </span>
        </div>
        <div class="newprice">
          <span>
            <div class="newpriced"
                 v-if="isGroup">¥{{item.total_price/100}}</div>
            <div class="newpricet"
                 :class="{newpriced2: !isGroup}">¥{{item.real_price/100}}</div>
            <div class="newprices"
                 v-if="isGroup">团购价</div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import api from '@/api'
import utils from '@/utils/utils'
import { ORDER_STATUS, STATE_MAP } from '@/utils/constants'
import { mapActions } from 'vuex'

export default {
  name: 'OrderItem',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      orderStatus: ORDER_STATUS,
      stateMap: STATE_MAP,
      timer: null,
      timestamp: '',
      groupState: true // 判断是否团购,
    }
  },
  mounted () {
    this.startTimer()
  },
  methods: {
    ...mapActions(['addCar']),
    addCart (e, item) {
      const $element = $(e.currentTarget)
      const goodsIds = []
      item.various.forEach((singleOrder) => {
        goodsIds.push(singleOrder.goods_id)
      })
      if (goodsIds && goodsIds.length) {
        this.addCar({
          goodsIds,
          goodsType: this.item.various[0].goods_type,
          callback: () => {
            utils.ballAnimation($element)
            item.addCarDisabled = true
          }
        })
      }
    },
    // 取消订单
    cancelPay (data) {
      this.$showDialog('确认取消订单', () => {
        api.cancelOrder({ order_no: data }).then(res => {
          if (res.data.code === 1) {
            this.$emit('cancel')
          } else {
            this.$message.warning(res.data.message)
          }
          this.loading = false
        })
      })
    },
    // 查看订单
    findOrder () {
      if (this.item.product_type === 15) {
        return false
      }
      this.$router.push({ path: 'orderDetail/' + this.item.order_no })
    },
    startTimer () {
      if (Number(this.item.state) !== Number(this.stateMap.NOT_PAY)) return
      const payEndTime = Number(this.item.order_at) + 30 * 60
      this.timestamp = Math.floor(payEndTime) - Math.floor($.now() / 1000)
      if (Number(this.timestamp) < 1) {
        this.item.state = 3
      }
      this.timer = window.setInterval(() => {
        if (Number(this.timestamp) < 1) {
          this.item.state = 3
          clearInterval(this.timer)
        } else {
          this.timestamp -= 1
        }
      }, 1000)
    },
    goPay (orderNo) {
      this.zhuGeEventTrack(this.zhugeEvents.MY_CLASS.GO_PAY_CLICK)
      this.$router.push({ path: '/pay/' + orderNo })
    },
    goCourseDetail (item) {
      this.zhuGeEventTrack(this.zhugeEvents.MY_CLASS.COURSE_DETAIL_CLICK, [this.orderStatus[item.state]])
      this.$router.push({ path: '/class-detail/' + item.class_id })
    },
    // 分享团购
    showGroup () {
      const orderInfo = this.item.various[0]
      this.$router.push({
        path: '/groupActivity/' + orderInfo.activity_info.group_id,
        query: { isPaided: true }
      })
    }
  },
  computed: {
    showOrder () {
      const productType = Number(this.item.various[0].goods_type)
      return productType === 5 || productType === 2 || productType === 13 || productType === 15
    },
    isGroup () {
      let groupInfo = {}
      this.item.various.forEach(item => {
        if (item.goods_type === 5 || item.goods_type === 2) {
          groupInfo = item
        }
      })
      return groupInfo.activity_id > 0 && groupInfo.activity_type === 1
    },
    isNotPay () {
      if (Number(this.item.product_type) === 15) {
        return false
      }
      return Number(this.item.state) === Number(this.stateMap.NOT_PAY)
    },
    showAddCard () {
      if (this.item.product_type === 15) {
        return false
      }
      return (Number(this.item.state) === Number(this.stateMap.TIMEOUT) || Number(this.item.state) === Number(this.stateMap.HAS_CANCELED)) && !this.isGroup
    },
    showShareBtn () {
      // const orderInfo = this.item.various[0]
      let orderInfo = {}
      this.item.various.forEach(item => {
        if (item.goods_type === 5 || item.goods_type === 2) {
          orderInfo = item
        }
      })
      return orderInfo.activity_type === 1 && Number(this.item.state) === 2 && Number(orderInfo.activity_info.state) === 1
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="scss">
@import "../../assets/scss/_base.scss";

.order-panel {
  position: relative;
  border: 1px solid rgba(51, 51, 51, 0.06);
  margin-bottom: 24px;
  border-radius: 2px;
  background-color: #fff;
  overflow: hidden;
  text-align: left;
  margin-top: 24px;
  min-height: 154px;

  .fa-tuan {
    font-size: 24px;
    color: red;
    position: relative;
    top: 5px;
    padding-right: 5px;
  }

  .go-pay {
    margin-bottom: 5px;
  }

  .visible-xs {
    display: none !important;
  }

  .title {
    color: rgba(44, 45, 46, 0.5);
    background-color: #fafafa;
    padding: 10px 20px;
    line-height: 24px;
    border-bottom: 1px solid rgba(51, 51, 51, 0.06);

    .detail {
      font-size: 12px;
    }

    .order-no {
      margin-left: 40px;
    }

    .pull-right {
      float: right;

      span {
        font-weight: 500;
      }

      &.default {
        span {
          color: rgba(193, 193, 193, 1);
        }

        i {
          background: rgba(193, 193, 193, 1);
        }
      }

      &.success {
        span {
          color: $brand-success;
        }

        i {
          background: $brand-success;
        }
      }

      &.warning {
        span {
          color: #ffc954;
        }

        i {
          background: #ffc954;
        }
      }

      .time-wrap {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.6);
        line-height: 14px;
        margin-left: 16px;

        .time {
          color: rgba(239, 77, 60, 0.8);
        }
      }
    }
  }

  hr {
    display: none;
  }

  .btn-cancel {
    color: rgba(51, 51, 51, 0.4);
    cursor: pointer;
    @media (max-width: 767px) {
      display: inline-block;
      margin-left: 20px;
    }
  }

  .order-type {
    text-align: center;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 9px;
    padding: 2px 3px;

    &.live {
      border: 1px solid rgba(0, 199, 191, 1);
      color: rgba(0, 199, 191, 1);
    }

    &.offline {
      color: rgba(255, 160, 0, 1);
      border: 1px solid rgba(255, 160, 0, 1);
    }

    &.yingdi {
      color: rgba(255, 152, 124, 1);
      border: 1px solid rgba(255, 152, 124, 1);
    }
  }

  .order-content {
    position: relative;
    min-height: 108px;

    .fa-calendar {
      margin-right: 5px;
    }

    .item-class {
      min-height: 75px;
      position: relative;
      margin-bottom: 20px;
    }

    &.more_data {
      .item-class:before {
        position: absolute;
        content: " ";
        bottom: -26px;
        width: calc(100% - 160px - 180px);
        height: 1px;
        background: rgba(51, 51, 51, 0.08);
      }
    }

    .surplus {
      padding-top: 10px;
      padding-bottom: 4px;
      padding-left: 25px;
      @media (max-width: 767px) {
        & {
          padding-top: 0;
          padding-bottom: 30px;
          padding-left: 10px;
          margin-top: -16px;
        }
      }
    }

    .state {
      display: none;
    }

    .newpriced2 {
      color: #ffa000;
      text-decoration: blink;
    }

    &.more_data {
      .newpriced2 {
        padding-top: 30px;
        height: 500px;
        vertical-align: top;
      }

      @media (min-width: 767px) {
        .newbtn {
          > span {
            vertical-align: top;
            top: 24px;
            transform: translateY(0);
          }
        }
      }
    }

    @media (max-width: 767px) {
      .go-pay {
        margin-bottom: 0;
      }
      &.more_data .newprice span {
        text-align: right;

        .newpriced2 {
          height: auto;
        }
      }
    }

    .order-name {
      font-size: 16px;
      font-weight: 500;
      color: rgba(30, 30, 30, 1);
      line-height: 18px;
      margin-bottom: 10px;
    }

    .neworder-name {
      width: 64%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: 767px) {
        width: 100%;
      }

      .order_time {
        img {
          width: 15px;
          height: 14px;
          position: relative;
          top: 3px;
          margin-right: 10px;
        }

        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.8);
      }
    }

    .neworder-name,
    .newdetail {
      padding-left: 8px;
    }

    .detail {
      font-size: 14px;
      font-weight: 400;
      color: rgba(44, 45, 46, 0.91);
      line-height: 14px;

      i {
        color: #999999;
        margin-right: 8px;
      }
    }

    .newbtn {
      > span {
        display: table-cell;
        vertical-align: middle;
        position: relative;
        top: 50%;
        transform: translateY(-50%);

        a {
          display: block;
          color: #606266;
        }
      }

      button {
        width: 90px;
        @media (max-width: 767px) {
          width: auto;
        }
      }

      .phone-gopay {
        width: 108px;
        margin-bottom: 15px;
      }

      .class-detail {
        background: transparent;
        font-weight: 400;
        border: none;
      }
    }
  }

  .status-divider-v {
    display: inline-block;
    width: 2px;
    height: 12px;
    border-radius: 1px;
    vertical-align: middle;
    margin: -3px 5px 0;
  }

  @media (max-width: 767px) {
    .title {
      padding: 10px;

      .pull-right {
        display: none;
      }

      span.order-no {
        margin-left: 8px;
      }

      .hidden-xs {
        display: none;
      }
    }

    .visible-xs {
      display: inline-block !important;
    }
    .order-content {
      padding: 16px 10px;
      position: relative;

      div.newbtn {
        float: none;
        margin-top: 0;
      }

      div.newbtn {
        display: flex;
        flex-direction: row-reverse;
        box-sizing: border-box;
        padding-right: 9px;
        margin-bottom: 15px;
        position: absolute;
        right: 0;
        bottom: -20px;

        &.camp {
          bottom: -13px;

          a {
            display: inline-block;
            margin-right: 10px;
          }
        }
      }

      div.newprice {
        position: absolute;
        bottom: -10px;
        left: 56px;

        .newpriced {
          color: rgba(51, 51, 51, 0.3);
          text-decoration: line-through;
          margin-bottom: 2px;
        }

        .newprices {
          position: relative;
          left: -46px;
          top: -18px;
        }

        .newpriced2 {
          position: relative;
          top: -27px;
          left: -38px;
        }

        .newpricet,
        .newprices {
          color: #ef4d3c;

          &.newpriced2 {
            color: #ffa000;
          }
        }
      }

      p.state {
        display: block;
        position: absolute;
        top: -35px;
        right: 10px;

        &.default {
          span {
            color: rgba(193, 193, 193, 1);
          }

          i {
            background: rgba(193, 193, 193, 1);
          }
        }

        &.success {
          span {
            color: $brand-success;
          }

          i {
            background: $brand-success;
          }
        }

        &.warning {
          span {
            color: #ffc954;
          }

          i {
            background: #ffc954;
          }
        }

        span.time-wrap {
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 0.6);
          line-height: 14px;
          margin-left: 16px;

          .time {
            color: rgba(239, 77, 60, 0.8);
          }
        }
      }
    }
    hr {
      display: block;
      margin: 22px 0;
      border: none;
      border-top: 1px solid rgba(51, 51, 51, 0.08);
    }
  }
}

.newbtn {
  padding: 0;
  white-space: initial;
  cursor: pointer;
}

@media (min-width: 767px) {
  .order-panel .order-content .newbtn {
    width: 180px;
    display: table;
    position: absolute;
    right: 0;
    bottom: 0;
    top: 0;
    text-align: center;
    height: 100%;

    &.camp {
      width: auto;

      a {
        display: inline-block;
        margin-right: 10px;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;

        &.btn-90 {
          width: 90px;
          height: 30px;
          line-height: 30px;
          padding: 0;
        }

        &.btn-110 {
          width: 130px;
          height: 30px;
          line-height: 30px;
          padding: 0;
          color: #fff;
          background-color: #5b9ce4;
        }
      }
    }
  }
  .newprice {
    text-align: center;
    width: 159px;
    border-left: 1px solid rgba(51, 51, 51, 0.08);
    border-right: 1px solid rgba(51, 51, 51, 0.08);
    height: 100%;
    position: absolute;
    right: 180px;
    top: 0;
    bottom: 0;
    display: table;
    min-height: 108px;

    > span {
      display: table-cell;
      vertical-align: middle;
    }

    .newpriced {
      color: rgba(51, 51, 51, 0.3);
      text-decoration: line-through;
      margin-bottom: 2px;
    }

    .newpricet {
      color: rgba(239, 77, 60, 1);
      margin-bottom: 4px;
    }

    .newprices {
      width: 40px;
      height: 16px;
      font-size: 11px;
      color: rgba(239, 77, 60, 1);
      margin: auto;
      background: rgba(239, 77, 60, 0.12);
    }
  }
  .neworder-name {
    position: relative;
    top: 24px;
    left: 13px;
  }
  .newdetail {
    position: relative;
    top: 24px;
    left: 13px;
  }
}

@media (min-width: 300px) and (max-width: 768px) {
  .order-panel .order-content .newbtn .phone-gopay {
    margin-bottom: 0;
  }
}

@media (min-width: 300px) and (max-width: 370px) {
  .order-panel .title {
    height: 42px;
  }
  .order-panel .order-content p.state {
    position: relative;
    left: 146px;
    top: -27px;
  }
}
</style>
